export const Pound = value => `£${parseFloat(value).toFixed(2)}`
export const PoundRaw = value => parseFloat(value).toFixed(2)
